import { message } from 'antd';

// 上传图片时验证一下图片
export function verifyImage(file: Blob) {
  if (!file) return false;
  const typeList = ['png', 'jpg', 'jpeg'];

  const { size, type } = file;
  const imgType = type.split('/').slice(-1)[0];
  if (typeList.indexOf(imgType) < 0) {
    message.error('只支持png、jpg(jpeg)格式的图片');
    return false;
  }
  if (size / (1024 * 1024) - 5 > 0) {
    message.error('图片大小超出限制(5M)，请更换图片');
    return false;
  }

  return true;
}
